// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__saBV9","inner":"Carousel_inner__Ity7z","carouselItem":"Carousel_carouselItem__X3Eml","arrows":"Carousel_arrows__DO1gj"};